// extracted by mini-css-extract-plugin
export default {"root":"LayoutSingleColumn_root__A2vUK","topbar":"LayoutSingleColumn_topbar__hJg2i","main":"LayoutSingleColumn_main__Nyvu9","footer":"LayoutSingleColumn_footer__kmGfG"};